import { render, staticRenderFns } from "./DetailsInformationFrundInfoAcc.vue?vue&type=template&id=584af580&"
import script from "./DetailsInformationFrundInfoAcc.vue?vue&type=script&lang=js&"
export * from "./DetailsInformationFrundInfoAcc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports